import React from 'react'
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
const ProductItem = ({product}) => {
      return (
        <>
          <td className="sticky md:static left-0 z-10 bg-white md:bg-inherit border-l-0 border-r-2 border-r-gray-400/20 p-1 md:p-3 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
            <figure className="flex flex-col items-center gap-1 md:flex-row md:gap-3">
              <div className="w-[50px] md:w-[100px] shrink-0">
                <Image
                  src={
                    product?.image[0]
                      ? product?.image[0]
                      : "./../img/imgnotavailable.png"
                  }
                  alt={product?.name}
                  loading="lazy"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <figcaption className="flex-1 text-center md:text-left text-[10px] md:text-sm font-bold text-gray-800 text-ellipsis overflow-hidden max-w-[80px] md:max-w-[150px] hover:text-orange-400 transition-colors duration-300 ease-in-out">
                <Link to={`/products/${product?._id}`}>{product?.name}</Link>
              </figcaption>
            </figure>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>
              {product?.Manufacturer}
            </Link>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>{product?.stock}</Link>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>{product?.price}$</Link>
          </td>
          <td className="transition-colors duration-300 ease-in-out hover:text-orange-400 border-r-2 border-r-gray-400/20 p-1 md:p-3 text-[10px] md:text-sm text-center font-bold text-gray-800">
            <Link to={`/products/${product?._id}`}>
              {product?.CTYEA_Part_Number}
            </Link>
          </td>
        </>
      );
}

export default ProductItem
